export const inRange = (value: number, min: number, max: number) => {
  return value >= min && value <= max;
};

export function areEqualArrays<T>(arr1: T[], arr2: T[]) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  return arr1.every((value) => arr2.indexOf(value) !== -1);
}

export const getNumericObjectValues = (type: Object) =>
  Object.values(type).filter((value) => typeof value === 'number');
